// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".e8e73c3d5a225cb9c37967ba15de79e1.js";
};